import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
import siteConfig from '../siteConfig.json'
import blogDoc from '../documents/blogs'

const blogArticleRoutes = blogDoc.articles.map((article) => ({
	path: article.url,
	name: article.name,
	meta: {
		appname: 'GB Apps',
		title: article.title,
		keywords: 'GB WhatsApp, GB WhatsApp guide',
		description: article.desc,
		link: [{ rel: 'canonical', href: `https://${siteConfig.domain}${article.url}` }],
	},
	component: () => import('@/views/BlogArticle.vue'),
}))

const routes = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GB WhatsApp',
			title: 'GB WhatsApp Download APK v18.80 Latest Version (2026) | GB Apps',
			keywords: 'GB WhatsApp',
			description:
				'Download the latest GB WhatsApp APK v18.80 for Android. Get anti-ban features, custom themes, privacy controls, update guides, old versions, and troubleshooting tips.',
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/` }],
		},
		component: () => import('@/views/home.vue'),
	},
	{
		path: '/download/',
		name: 'download',
		meta: {
			appname: 'GB WhatsApp',
			title: 'Download GB WhatsApp Real APK for Android',
			keywords: 'GB WhatsApp APK download, GB WhatsApp download',
			description:
				'Download GB WhatsApp APK v18.80 latest version for Android. Get the updated APK file, version details, installation steps, and update information.',
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/download/` }],
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/old-versions/',
		name: 'old-versions',
		meta: {
			appname: 'GB WhatsApp',
			title: 'GB WhatsApp Old Versions APK Download (2026) | Previous Releases',
			keywords: 'GB WhatsApp old versions, GB WhatsApp previous versions',
			description:
				'Download old versions of GB WhatsApp APK for Android. Find previous releases, version details, update dates, file sizes, and compatible Android versions.',
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/old-versions/` }],
		},
		component: () => import('@/views/old-versions.vue'),
	},
	{
		path: '/for-pc/',
		name: 'for-pc',
		meta: {
			appname: 'GB WhatsApp',
			title: 'GBWhatsApp for PC Windows 11/10 (2026) – Use GB WhatsApp on Computer',
			keywords: 'GB WhatsApp for PC, GBWhatsApp Windows',
			description:
				'Use GBWhatsApp on PC with Windows 11 and Windows 10. Learn how to install GB WhatsApp using Android emulators and run it on your computer.',
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/for-pc/` }],
		},
		component: () => import('@/views/for-pc.vue'),
	},
	{
		path: '/blog/',
		name: 'blog',
		meta: {
			appname: 'GB Apps',
			title: blogDoc.blogMeta.title,
			keywords: 'GB WhatsApp blog, GB WhatsApp guides, GB WhatsApp updates',
			description: blogDoc.blogMeta.description,
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/blog/` }],
		},
		component: () => import('@/views/blogs.vue'),
	},
	...blogArticleRoutes,
	{
		path: '/about-us/',
		name: 'about-us',
		meta: {
			appname: 'GB Apps',
			title: 'About GB Apps',
			keywords: 'About GB Apps, GB WhatsApp',
			description:
				'Learn about GB Apps, a website providing GB WhatsApp APK information, updates, installation guides, features, and helpful Android resources.',
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/about-us/` }],
		},
		component: () => import('@/views/about-us.vue'),
	},
	{
		path: '/contact/',
		name: 'contact',
		meta: {
			appname: 'GB Apps',
			title: 'Contact GB Apps – Get in Touch With Us',
			keywords: 'Contact GB Apps',
			description:
				'Contact GB Apps for questions, feedback, corrections, or suggestions about GB WhatsApp guides, APK information, and website content.',
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/contact/` }],
		},
		component: () => import('@/views/contact.vue'),
	},
	{
		path: '/privacy-policy/',
		name: 'privacy-policy',
		meta: {
			appname: 'GB Apps',
			title: 'Privacy Policy – GB Apps',
			keywords: 'Privacy Policy, GB Apps',
			description:
				'Read the GB Apps privacy policy to learn how we collect, use, and protect visitor information while you browse our website.',
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/privacy-policy/` }],
		},
		component: () => import('@/views/privacy.vue'),
	},
	{
		path: '/terms-and-conditions/',
		name: 'terms-and-conditions',
		meta: {
			appname: 'GB Apps',
			title: 'Terms and Conditions – GB Apps',
			keywords: 'Terms and Conditions, GB Apps',
			description:
				'Read the GB Apps terms and conditions to understand website usage rules, content guidelines, and user responsibilities.',
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/terms-and-conditions/` }],
		},
		component: () => import('@/views/terms.vue'),
	},
	{
		path: '/disclaimer/',
		name: 'disclaimer',
		meta: {
			appname: 'GB Apps',
			title: 'Disclaimer – GB Apps',
			keywords: 'Disclaimer, GB Apps',
			description:
				'Read the GB Apps disclaimer about third-party applications, APK information, external links, and website content limitations.',
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/disclaimer/` }],
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	{
		path: '/dmca/',
		name: 'dmca',
		meta: {
			appname: 'GB Apps',
			title: 'DMCA Policy – GB Apps',
			keywords: 'DMCA Policy, GB Apps',
			description:
				'Learn about GB Apps DMCA policy and how to submit copyright removal requests or report content-related concerns.',
			link: [{ rel: 'canonical', href: `https://${siteConfig.domain}/dmca/` }],
		},
		component: () => import('@/views/dmca.vue'),
	},
]

const siteMapRoutes = routes.map((e) => ({
	path: e.path,
}))
export { siteMapRoutes }
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
